import styled from 'styled-components';
import {
  color,
  container,
  fontSize,
  radius,
  screen,
  spacing
} from '../../theme';

export const StyledContainer = styled.div`
  padding: ${spacing('xl4')} ${spacing('md')};
  max-width: ${container('lg')};
  margin: auto;
`;

export const StyledHeader = styled.div`
  text-align: center;
  margin-bottom: ${spacing('lg')};
  line-height: 1.5;

  @media (min-width: ${screen('md')}) {
    font-size: ${fontSize('lg')};
    line-height: 1.6;
    margin-bottom: ${spacing('xl4')};
  }
`;

export const StyledRoles = styled.div`
  margin-left: auto;
  margin-right: auto;
  max-width: ${container('sm')};
  background-color: ${color('white')};
  border: 1px solid ${color('midnight_200')};
  border-radius: ${radius('md')};

  > :first-child {
    border-top: 0;
  }
`;
